var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3452 6.84509C24.202 11.3034 21.8818 15.3727 18.6272 18.6272C15.3727 21.8818 11.3034 24.202 6.84509 25.3452C3.41458 26.2185 0.5 23.2686 0.5 19.7276V18.1253C0.5 17.2408 1.21943 16.531 2.09909 16.4428C3.00853 16.3524 3.90755 16.1845 4.78645 15.9413C5.75468 15.6735 6.81382 15.878 7.52418 16.5884C8.28276 17.347 9.4465 17.5581 10.3668 17.0067C13.0926 15.3737 15.3739 13.0924 17.0069 10.3665C17.5581 9.44638 17.347 8.28286 16.5886 7.52443C15.8782 6.81396 15.6738 5.75459 15.942 4.78631C16.1855 3.90749 16.3537 3.00851 16.4444 2.09909C16.531 1.21783 17.2408 0.5 18.1253 0.5H19.7276C23.2686 0.5 26.2185 3.41458 25.3452 6.84509Z",
    stroke: "#39322F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.100de60eb032ce44c3a53a7137586bca.svg";
export { ForwardRef as ReactComponent };